import api from './api';

export const login = async (email, password) => {
  const response = await api.post('/auth/login', { email, password });
  return response;
};

export const register = async (userData) => {
  const response = await api.post('/auth/register', userData);
  return response;
};

export const getCurrentUser = async () => {
  const response = await api.get('/auth/me');
  return response;
};

export const acceptInvite = async (token) => {
  const response = await api.post('/auth/accept-invite', { token });
  return response;
};

// Сменить пароль (из профиля, авторизованный)
export const changePassword = (currentPassword, newPassword) => api.put('/auth/password', { currentPassword, newPassword });

// Сброс пароля по email
export const forgotPassword = (email) => api.post('/auth/forgot-password', { email });
export const resetPassword = (token, password) => api.post('/auth/reset-password', { token, password });

// Обновить имя в профиле
export const updateProfile = async (data) => {
  const response = await api.put('/auth/profile', data);
  return response;
};

// Загрузить аватар (file — это File из <input type="file">)
export const uploadAvatar = async (file) => {
  const formData = new FormData();
  formData.append('avatar', file);
  const response = await api.post('/auth/avatar', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response;
};